import * as Yup from 'yup';

export const UpdateDriverPerformanceSchema = Yup.object().shape({
  reportType: Yup.string().required('Report type is required'),
  rating: Yup.string().required('Please select your rating'),
});

export interface UpdateDriverPerformanceDataType {
  reportType: string;
  rating: number;
}

export const UpdateDriverPerformanceInitialValues: UpdateDriverPerformanceDataType =
{
  reportType: '',
  rating: 0,
};

export interface UpdateDriverPerformanceInterface {
  reportType: string;
  rating: number;
}
